module.exports = __webpack_public_path__ + "img/resource-tech-image-05.ee10a857.jpg";